// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderStatusAlert_container__nX2pQ","description":"OrderStatusAlert_description__ptA8T"};